import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion } from "framer-motion";
import { FaLock, FaEye, FaEyeSlash, FaEnvelope } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/Slices/authSlice";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [shake, setShake] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading: loading } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setShake(true);
      toast.error("يجب إدخال البريد الإلكتروني وكلمة المرور", {
        position: "top-right",
        rtl: true,
      });
      setTimeout(() => setShake(false), 500);
      return;
    }

    try {
      await dispatch(loginUser({ email, password })).unwrap();
      toast.success("تم تسجيل الدخول بنجاح", {
        autoClose: 1500,
        onClose: () => {
          navigate("/");
        },
      });
    } catch (err) {
      setShake(true);
      toast.error("فشل تسجيل الدخول", {
        autoClose: 1500,
      });
      setTimeout(() => setShake(false), 500);
    }
  };

  const LoadingSpinner = () => (
    <div
      className="spinner-border text-light"
      role="status"
      style={{ width: "1.5rem", height: "1.5rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  );

  return (
    <div
      className="container-fluid d-flex p-0"
      style={{
        height: "100vh",
        background: "white",
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      

      {/* النموذج على اليمين */}
      <div className="col-md-6 col-12 d-flex justify-content-center align-items-center px-4">
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className={`card shadow-lg ${shake ? "shake-animation" : ""}`}
          style={{
            width: "100%",
            maxWidth: "450px",
            border: "none",
            borderRadius: "20px",
            overflow: "hidden",
            backgroundColor: "white",
          }}
        >
          <div className="card-body p-5">
            {/* اللوجو */}
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
              className="text-center mb-4"
            >
              <img
                src="/logo.jpeg"
                alt="logo"
                style={{
                  height: "150px",
                  width: "auto",
                }}
              />
            </motion.div>

            {/* عنوان مرحباً بعودتك */}
            <motion.h3
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              className="text-center mb-3 fw-bold"
              style={{ color: "#333" }}
            >
              مرحباً بعودتك
            </motion.h3>

            {/* نص يرجي تسجيل الدخول */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-center mb-4"
              style={{
                color: "var(--sub-color)",
                fontSize: "1.1rem",
                fontWeight: "500",
              }}
            >
              يرجي تسجيل الدخول
            </motion.p>

            <form onSubmit={handleSubmit}>
              {/* حقل البريد الإلكتروني */}
              <motion.div
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.6 }}
                className="mb-4"
              >
                <label
                  htmlFor="email"
                  className="form-label fw-medium"
                  style={{ color: "#333" }}
                >
                  البريد الإلكتروني
                </label>
                <div className="input-group" style={{ direction: "ltr" }}>
                  <span className="input-group-text bg-light">
                    <FaEnvelope className="text-secondary" />
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="example@example.com"
                    required
                    style={{
                      borderLeft: "none",
                      borderRadius: "0 8px 8px 0",
                    }}
                  />
                </div>
              </motion.div>

              {/* حقل كلمة المرور */}
              <motion.div
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.7 }}
                className="mb-4"
              >
                <label
                  htmlFor="password"
                  className="form-label fw-medium"
                  style={{ color: "#333" }}
                >
                  كلمة المرور
                </label>
                <div className="input-group" style={{ direction: "ltr" }}>
                  <span className="input-group-text bg-light">
                    <FaLock className="text-secondary" />
                  </span>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="********"
                    required
                    style={{ borderLeft: "none" }}
                  />
                  <button
                    type="button"
                    className="input-group-text bg-light"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="text-secondary" />
                    ) : (
                      <FaEye className="text-secondary" />
                    )}
                  </button>
                </div>
              </motion.div>

              {/* زر تسجيل الدخول */}
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                type="submit"
                className="btn w-100 text-white py-3 fw-medium"
                style={{
                  backgroundColor: "var(--main-color)",
                  border: "none",
                  borderRadius: "10px",
                  fontSize: "1.1rem",
                  marginTop: "1rem",
                }}
                disabled={loading}
              >
                {loading ? <LoadingSpinner /> : "تسجيل الدخول"}
              </motion.button>
            </form>
          </div>
        </motion.div>
      </div>

      {/* الصورة على الشمال */}
      <div
        className="col-md-6 d-none d-md-block p-0"
        style={{ height: "100vh" }}
      >
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="h-100"
        >
          <img
            src="/bg-card.png"
            alt="Login"
            className="img-fluid h-100 w-100"
            style={{
              objectFit: "cover",
              boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
              height: "100vh",
            }}
          />
        </motion.div>
      </div>

      {/* الانيميشن الدائري */}
      <div className="position-fixed top-0 end-0 m-4">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
          style={{
            width: "150px",
            height: "150px",
            border: "2px dashed white",
            borderRadius: "50%",
            position: "absolute",
            top: "-50px",
            right: "-50px",
          }}
        />
      </div>
    </div>
  );
};

export default LoginPage;
